import { CloseOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { TESelectionType, ThemeEnginePanel } from '../../../constants';
import { Gray6 } from '../../../styles';
import { suggestedThemeType, themeType } from '../../../types';

const { Text } = Typography;

const StyledCloseButton = styled(Button)`
  color: ${Gray6};
`;

function SelectedThemesList({
  panel,
  selectedThemes,
  handleSelection,
  setVisible,
  className = '',
}) {
  return (
    <Flex vertical gap={8} className={className}>
      <Text type="secondary">Selected themes</Text>
      <Flex vertical gap={4}>
        {selectedThemes.map((theme) => (
          <Flex justify="space-between" key={theme.id} align="center">
            <Text>{theme.name}</Text>
            <StyledCloseButton
              type="text"
              size="small"
              shape="circle"
              icon={<CloseOutlined />}
              onClick={() => {
                handleSelection({
                  type:
                    panel === ThemeEnginePanel.MY_CODE_FRAME
                      ? TESelectionType.THEME
                      : TESelectionType.SUGGESTED_THEME,
                  id: theme.id,
                  checked: false,
                });
                if (selectedThemes.length === 1) {
                  setVisible(false);
                }
              }}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}

SelectedThemesList.propTypes = {
  panel: PropTypes.string.isRequired,
  selectedThemes: PropTypes.arrayOf(PropTypes.oneOfType([themeType, suggestedThemeType]))
    .isRequired,
  handleSelection: PropTypes.func.isRequired,
  setVisible: PropTypes.func.isRequired,
  // We need className so we can create a styled SelectedThemesList
  className: PropTypes.string,
};

export default SelectedThemesList;
